import Common from "../../../Common";

interface Body {
	permission: number
	permission_template_id: id
}

const Permission = class extends Common {
	browse = (groupId: id) =>
		this.get(`/acl/group/${groupId}/permission`)

	create = (groupId: id, body: Body) =>
		this.post(`/acl/group/${groupId}/permission`, body)
}

export default Permission
